import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RouteDefine} from "../../../../routes/RouteDefine";
import {DashboardModuleKey} from "./DashboardModuleCard";

type DashboardScheduleSnippetProps = {
    activeCount: number;
    totalCount: number;
    scheduledTypes: string[];
    enabledModules: Array<{key: DashboardModuleKey; titleKey: string}>;
    loading?: boolean;
};

const DashboardScheduleSnippet: React.FC<DashboardScheduleSnippetProps> = ({
    activeCount,
    totalCount,
    scheduledTypes,
    enabledModules,
    loading = false,
}) => {
    const {t} = useTranslation();

    const missing = enabledModules.filter((m) => !scheduledTypes.includes(m.key));

    return (
        <div className="col-12">
            <div className="business-detail bg-orange-bland-zp bdr-20 pd-25">
                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                    <div>
                        <h2 className="fw-bold fs-20 mb-1">{t("common.dashboard.scheduleTitle")}</h2>
                        {loading ? (
                            <div className="placeholder-glow">
                                <span className="placeholder col-6"/>
                            </div>
                        ) : (
                            <>
                                <p className="text-muted mb-1 small">
                                    {totalCount > 0
                                        ? t("common.dashboard.scheduleSummary", {
                                            active: activeCount,
                                            total: totalCount,
                                        })
                                        : t("common.dashboard.scheduleEmpty")}
                                </p>
                                {missing.length > 0 ? (
                                    <p className="text-warning mb-0 small">
                                        {t("common.dashboard.scheduleMissingModules", {
                                            modules: missing.map((m) => t(m.titleKey)).join(", "),
                                        })}
                                    </p>
                                ) : totalCount > 0 && enabledModules.length > 0 ? (
                                    <p className="text-muted mb-0 small">
                                        {t("common.dashboard.scheduleAllModulesCovered")}
                                    </p>
                                ) : null}
                            </>
                        )}
                    </div>
                    <Link to={RouteDefine.settingsSchedule} className="btn btn-sm btn-primary">
                        {totalCount > 0
                            ? t("common.dashboard.manageSchedules")
                            : t("common.dashboard.createSchedule")}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DashboardScheduleSnippet);
